import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { take } from "rxjs/operators";
import { finalize } from "rxjs/operators";
import { exportExcel } from "src/app/helpers/helpers";

@Component({
  selector: "app-root-utm-link-logs",
  templateUrl: "./root-utm-link-logs.component.html",
  styleUrls: ["./root-utm-link-logs.component.scss"],
})
export class RootUtmLinkLogsComponent implements OnInit {
  isReportReady = false;
  data = [];
  loading = false;
  utmLink = "";

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.getReport();
  }

  getReport() {
    this.loading = true;
    this.http
      .get("/utm-link-logs", { params: { utmLink: this.utmLink } })
      .pipe(
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((res: any[]) => {
        this.data = res || [];
        this.isReportReady = true;
      });
  }

  async downloadExcel() {
    if (!this.isReportReady) {
      return;
    }

    const output = [];

    for (const item of this.data) {
      output.push({
        ["Telefon No"]: item.phoneNumber,
        ["Anket Adı"]: item.surveyName,
        ["Tarih"]: moment(item.createdOn).format("DD.MM.YYYY HH:mm"),
        ["UTM Link"]: item.utmLink,
      });
    }

    exportExcel(output, "utm-link-raporlari");
  }
}
